import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-version-slider',
  templateUrl: './version-slider.component.html',
})
export class VersionSliderComponent implements OnInit, OnChanges {

  showBox = false;
  @Input() appDetail;
  @Input() showUpdate = false;
  updateStep1 = true;
  currentVersion = '';
  @Output() updateNotify = new EventEmitter();
  @Output() closePopUp = new EventEmitter();
  constructor() { }
  ngOnChanges(): void {
  }

  ngOnInit(): void {
    this.checkUpdate();
  }
  checkUpdate() {
    if (this.appDetail != null) {
      this.currentVersion = this.appDetail.currentVersion;
      if (this.appDetail.features) {
        this.appDetail.features = this.appDetail.newestAvailableVersionReleaseNote.split('-');
        this.appDetail.features.shift();
      }
      if (this.appDetail.newestAvailableVersion !== null) {
        if (this.appDetail.currentVersion === this.appDetail.newestAvailableVersion) {
          this.updateStep1 = false;
        }
      }
    }
  }
  updateApp() {
    this.appDetail.currentVersion = this.appDetail.newestAvailableVersion;
    localStorage.setItem('appDetail', JSON.stringify(this.appDetail));
    this.showUpdate = false;
    setTimeout(() => {
    this.updateNotify.emit();
    }, 1000);
  }
  closePopup() {
    this.closePopUp.emit();
  }

}
